import { BucketItem } from 'minio'

export interface ELibraryStateInterface {
  directoryObjectList: Array<BucketItem>;
  fileObjectList: Array<BucketItem>;
  selectedObject: Array<BucketItem>;
  selectedObjectClipboard: Array<BucketItem>;
  totalStorageUsed: number;
}

export default function (): ELibraryStateInterface {
  return {
    directoryObjectList: [],
    fileObjectList: [],
    selectedObject: [],
    selectedObjectClipboard: [],
    totalStorageUsed: -1
  }
}
